module.exports = __webpack_public_path__ + "img/ic_20_answer.47e9851b.svg";